import React, {Component} from 'react';
import {
    FaAngleDoubleLeft,
    FaAngleDoubleRight,
    FaCheck,
    FaCheckDouble,
    FaExchangeAlt,
    FaHome,
    FaSearch,
    FaSign,
    FaStreetView,
    FaTruckMoving,
    FaUmbrellaBeach,
    FaUser, FaUserCircle,
    FaUserFriends
} from "react-icons/fa";
import SmartFormGroup from "../../inputs/SmartFormGroup";
import {Col, Container, Row} from "react-bootstrap";
import Navbar from "react-bootstrap/Navbar";
import {Link} from "react-router-dom";
import logo from "../../../assets/images/logo.svg";
import Register from "./Register";
class SignUpFlow extends Component {
    getTransitionName = () => {
        let el = document.createElement('div')
        let transEndEventNames = {
            WebkitTransition: 'webkitTransitionEnd',
            MozTransition: 'transitionend',
            OTransition: 'oTransitionEnd otransitionend',
            transition: 'transitionend'
        }
        for (var name in transEndEventNames) {
            if (el.style[name] !== undefined) {
                return transEndEventNames[name];
            }
        }
        return false
    }
    state = {
        values: {},
        forwards: true,
        index: 0,
        transitionName: this.getTransitionName()
    }
    questions = [
        {
            name: "mortgagePurpose",
            text: "What is the purpose of this mortgage?",
            answer: {
                type: "choice",
                choices: [
                    {
                        text: "First-time buyer",
                        value: "FIRSTTIME",
                        icon: <FaHome size={23}/>
                    },
                    {
                        text: "Buy-to-let",
                        value: "BUYTOLET",
                        icon: <FaSign/>
                    },
                    {
                        text: "Moving home",
                        value: "MOVING",
                        icon: <FaTruckMoving/>
                    },
                    {
                        text: "2nd home",
                        value: "HOLIDAYHOME",
                        icon: <FaUmbrellaBeach/>
                    },
                    {
                        text: "Switch mortgage",
                        value: "REFINANCE",
                        icon: <FaExchangeAlt/>

                    }
                ]
            }
        },
        {
            name: "goingAlone",
            text: "How many applicants will there be?",
            answer: {
                type: 'choice',
                choices: [
                    {
                        value: true,
                        text: 'One',
                        icon: <FaUser/>

                    },
                    {
                        value: false,
                        text: 'Two',
                        icon: <FaUserFriends/>
                    }
                ]
            }
        },
        {
            name: "app1DateOfBirth",
            text: "What is your date of birth?",
            answer: {
                type: "ddmmyyyy",
            }
        },
        {
            name: "app2DateOfBirth",
            text: "What is the other applicant's date of birth?",
            answer: {
                type: "ddmmyyyy",
            },
            omitted: () => {
                return this.state.values.goingAlone === true
            }
        },
        // {
        //     name: "totalDependants",
        //     text: () => {
        //         return `How many dependent children do you have${false === this.state.values.goingAlone ? ' between you' : ''}?`
        //     },
        //     answer: {
        //         type: "choice",
        //         choices: [
        //             {
        //                 text: "None",
        //                 value: 0
        //             }, {
        //                 text: "One",
        //                 value: 1
        //             },
        //             {
        //                 text: "Two",
        //                 value: 2
        //             },
        //             {
        //                 text: "Three",
        //                 value: 3
        //             },
        //             {
        //                 text: "Four",
        //                 value: 4
        //             },
        //             {
        //                 text: "Five",
        //                 value: 5
        //             },
        //             {
        //                 text: "Six",
        //                 value: 6
        //             },
        //             {
        //                 text: "Seven",
        //                 value: 7
        //             }
        //         ]
        //     }
        // },
        {
            text: 'At what stage are you in the purchase process?',
            name: 'purchaseStage',
            answer: {
                type: 'choice',
                choices: [
                    {
                        value: 'RESEARCHING',
                        text: () => {
                            return (this.state.values.goingAlone ? 'I’m ' : 'We’re') + ' researching'
                        },
                        icon: <FaSearch/>

                    },
                    {
                        value: 'VIEWING',
                        text: () => {
                            return (this.state.values.goingAlone ? 'I’m ' : 'We’re') + ' viewing properties'
                        },
                        icon: <FaStreetView/>

                    },
                    {
                        value: 'OFFERMADE',
                        text: () => {
                            return (this.state.values.goingAlone ? 'I’m ' : 'We’re') + ' ready to make an offer'
                        },
                        icon: <FaCheck/>

                    },
                    {
                        value: 'OFFERACCEPTED',
                        text: () => {
                            return (this.state.values.goingAlone ? 'I’ve ' : 'We’ve') + ' had an offer accepted'
                        },
                        icon: <FaCheckDouble/>

                    }
                ]
            },
            omitted: () => {
                return this.state.values.mortgagePurpose === 'REFINANCE'
            }
        },
        {
            text: () => {
                return this.state.values.mortgagePurpose !== 'REFINANCE' && this.state.values.purchaseStage === 'RESEARCHING' ? 'What is the average price you\'re looking at' : 'What is the value of the property?'
            },
            name: 'estimatedValue',
            answer: {
                type: 'euro',
                validation: {
                    min: {value: 60000, message: "This must be a value greater than Є60,000"},
                    max: {value: 1000000, message: "The maximum value here is Є1,000,000"}
                }
            }
        },
        {
            text: "What is your property's BER score?",
            name: 'berScore',
            answer: {
                type: 'choice',
                choices: [
                    {
                        value: 'A1',
                        text: 'A1',

                    },
                    {
                        value: 'A3',
                        text: 'A3',

                    },
                    {
                        value: 'B1',
                        text: 'B1',

                    },
                    {
                        value: 'B3',
                        text: 'B3',

                    },
                    {
                        value: 'C1',
                        text: 'C1',

                    },
                    {
                        value: 'C2',
                        text: 'C2',
                    },
                    {
                        value: 'C3',
                        text: 'C3',

                    },
                    {
                        value: 'D1',
                        text: 'D1',

                    },
                    {
                        value: 'D2',
                        text: 'D2',
                    },
                    {
                        value: 'E',
                        text: 'E',
                    },
                    {
                        value: 'F',
                        text: 'F',
                    },
                    {
                        value: 'UNKNOWN',
                        text: "I don't know",
                    }
                ]
            },
            omitted: () => {
                return this.state.values.mortgagePurpose !== 'REFINANCE'
            }
        },
        {
            text: () => {
                return this.state.values.mortgagePurpose === 'REFINANCE' ? 'What is the amount of your outstanding mortgage?' : 'How much do you want to borrow?'
            },
            name: 'borrowAmount',
            answer: {
                type: 'euro',
                validation: {
                    min: {value: 50000, message: "This must be a value greater than Є50,000"},
                    max: {value: 1000000, message: "The maximum value here is Є1,000,000"}
                }
            }
        },
        {
            text: () => {
                return this.state.values.mortgagePurpose === 'REFINANCE' ? 'How many years are remaining on that mortgage?' : 'Over how many years do you want to borrow?'
            },
            name: 'borrowTerm',
            answer: {
                type: 'int',
                validation: {
                    min: {value: 5, message: "The minimum term is 5 years"},
                    max: {value: 35, message: "The minimum term is 35 years"}
                }
            }
        },
        // {
        //     text: "What is your current interest rate?",
        //     name: 'existingRate',
        //     answer: {
        //         type: 'float',
        //         validation: {
        //             min: {value: 1, message: "This must be a value greater than 1%"},
        //             max: {value: 10, message: "The maximum value here is 10%"}
        //         }
        //     },
        //     omitted: () => {
        //         return this.state.values.mortgagePurpose !== 'REFINANCE'
        //     }
        // },
        {
            text: "How much do you pay every month?",
            name: 'existingPayment',
            answer: {
                type: 'euro',
                validation: {
                    min: {value: 100, message: "This must be a value greater than Є100"},
                    max: {value: 10000, message: "The maximum value here is Є10,000"}
                }
            },
            omitted: () => {
                return this.state.values.mortgagePurpose !== 'REFINANCE'
            }
        },
        {
            text: () => {
                return `What are your ${this.state.values?.goingAlone ? '' : 'combined '} gross earnings per year?`
            },
            name: 'grossEarnings',
            answer: {
                type: 'euro',
                validation: {
                    min: {value: 10000, message: "This must be a value greater than Є10,000"},
                    max: {value: 1000000, message: "The maximum value here is Є1,000,000"}
                }
            },
            omitted: () => {
                return this.state.values.mortgagePurpose === 'REFINANCE'
            }
        },
        // {
        //     text: () => {
        //         return `How much of your ${this.state.values?.goingAlone ? '' : 'combined '}monthly outgoings are loan repayments?`
        //     },
        //     name: 'monthlyLoanRepayments',
        //     answer: {
        //         type: 'euro',
        //         validation: {
        //             min: {value: 10, message: "This must be a value greater than Є10"},
        //             max: {value: 10000, message: "The maximum value here is Є10,000"}
        //         }
        //     }
        // }
    ]
    nextVisibleIndex = (prevIndex) => {
        return this.questions.findIndex((item, i) => {
            return i > prevIndex && (!item?.omitted || !item.omitted())
        })
    }
    prevVisibleIndex = (prevIndex) => {
        let i = prevIndex - 1;
        while (i >= 0) {
            let omitted = (this.questions[i]?.omitted && this.questions[i].omitted())
            if (!omitted) return i
            i--
        }
        return -1
    }
    advance = () => {
        this.setState(prevState => {
            const next = this.nextVisibleIndex(prevState.index)
            return {...prevState, index: next, forwards:true}
        })
    }
    retreat = () => {
        this.setState(prevState => {
            const prev = this.prevVisibleIndex(prevState.index)
            return {...prevState, index: prev, forwards:false}
        })
    }
    saveAnswer = (name, value) => {
        this.setState(prevState => {
            prevState.values[name] = value
            return prevState
        })
    }
    onBackFromRegister = ()=>{
        const q = this.questions.filter((item, i) => {
            return !item?.omitted || !item.omitted()
        })
        const lastName = q[q.length-1].name
        this.setState(prevState=>{
            prevState.index = this.questions.findIndex(item=>item.name===lastName)
            return prevState
        })
    }
    render() {
        if (this.state.index === -1){
            return <Register values={this.state.values} onBack={this.onBackFromRegister}/>
        }
        let q = {...this.questions[this.state.index]}
        q.text = (typeof q.text === 'function') ? q.text() : q.text
        if (q.answer.type === 'choice') {
            q.answer.choices = q.answer.choices.map(c => {
                c.text = (typeof c.text === 'function') ? c.text() : c.text
                return c
            })
        }
        const val = this.state.values[q.name]
        return (
            <>
                <Navbar bg="light" className="bg-white border-bottom">
                    <div className="container-lg d-flex justify-content-center align-items-center">

                            <Navbar.Brand as={Link} to="/">
                                <img alt="Sussd Logo" src={logo} style={{maxHeight: '60px',}}/>
                            </Navbar.Brand>



                        {/*<Nav className="ms-auto">*/}
                        {/*    <NavDropdown title={<FaUserCircle/>} id="nav-user-menu" align="end" className="no-caret">*/}
                        {/*        */}
                        {/*    </NavDropdown>*/}
                        {/*</Nav>*/}

                    </div>
                </Navbar>
                <Container>

                        <Transition
                            key={q.name}
                            transitionName={this.state.transitionName}
                            value={val}
                            question={q}
                            forwards={this.state.forwards}
                            saveAnswer={this.saveAnswer}
                            advance={this.advance}
                            retreat={this.retreat}
                            backPossible={this.state.index>0}
                            forwardPossible={true}
                        />
                </Container>
            </>
        );
    }
}

export default SignUpFlow;

class Transition extends Component {
    state = {
        entered: false,
        position: this.props.forwards ? 'bottom' : 'top',
    }
    answerRef = React.createRef()
    transitionTimeout = null
    onLoaded = () => {
        clearTimeout(this.transitionTimeout)
        this.transitionTimeout = setTimeout(() => {
            this.addLastDelayEvent(() => {
                const r = this.answerRef.current.querySelector('input.form-control')
                if (r) {
                    r.focus()
                }
                this.setState({entered: true})
            })
            this.setState({position: ''})
        }, 50) // an timeout to prevent state merging
    }

    goBack = () => {
        clearTimeout(this.transitionTimeout)
        this.addLastDelayEvent(this.props.retreat)
        this.setState({position: 'bottom'})
    }
    goForward = () => {
        //make a blur forward clearable when back is clicked
        //console.log('(goForward action added)')
        clearTimeout(this.transitionTimeout)
        this.transitionTimeout = setTimeout(() => {
            this.addLastDelayEvent(this.props.advance)
            this.setState({position: 'top'})
        }, 100)
    }
    goForwardIfAnswered = () =>{
        if (typeof this.props.value !== 'undefined'){
            console.log(this.props.value, ':(')
            return this.goForward()
        }
    }
    addLastDelayEvent = (callback) => {
        const delays = this.answerRef.current.querySelectorAll('.transitionable');
        if (delays.length) {
            if (this.props.transitionName) {
                const lastOut = () => {
                    delays[delays.length - 1].removeEventListener(this.props.transitionName, lastOut, true)
                    callback()
                }
                delays[delays.length - 1].removeEventListener(this.props.transitionName, lastOut, true)
                delays[delays.length - 1].addEventListener(this.props.transitionName, lastOut, true)
            } else {
                const timeOut = (delays.length + 1) * 0.08
                setTimeout(() => {
                    callback()
                }, timeOut)
            }
        }

    }
    saveAnswer = (value) => {
        this.props.saveAnswer(this.props.question.name, value)
        this.goForward()
    }
    componentDidMount() {
        this.onLoaded();
    }
    render() {
        return (
            <div className="d-flex flex-column gap-5">
                <button
                    className={`btn btn-sm btn-secondary me-auto ${this.props.backPossible ? '' : 'opacity-0'}`}
                    onClick={this.goBack}><FaAngleDoubleLeft/>
                    Back
                </button>
                <div ref={this.answerRef} className={`question-transition ${this.state.position}`}>
                    <SmartFormGroup
                        noLabel={true}
                        expandedStyle={'wizard'}
                        editing={true}
                        defaultValue={this.props.value}
                        saveAnswer={this.saveAnswer}
                        {...this.props.question}/>
                </div>
                <button
                    onClick={this.goForwardIfAnswered}
                    className={`ms-auto btn btn-sm btn-secondary ${this.props.forwardPossible ? '' : 'opacity-0'}`}>
                    Forward <FaAngleDoubleRight/>
                </button>
            </div>

        )
    }
}